import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { TachographDataPart } from "../models/Tachograph";
import { RESULTS_LIMIT_TACHOGRAPH_COMPANY_CARD } from "@/constants/resultsLimits";

type TachographDataStatusProps = {
  loadingParts: TachographDataPart[];
  failedParts: TachographDataPart[];
  companyCardsTruncated: boolean;
};

/** Which parts of the page are still loading or failed, and whether the company cards are cut off. */
export function TachographDataStatus({
  loadingParts,
  failedParts,
  companyCardsTruncated,
}: TachographDataStatusProps) {
  const { t } = useTranslation();
  const listParts = (parts: TachographDataPart[]) =>
    parts.map(part => t(`tachograph.dataParts.${part}`)).join(", ");

  return (
    <>
      {failedParts.length > 0 ? (
        <Alert severity="error">
          {t("tachograph.queryErrorParts", { parts: listParts(failedParts) })}
        </Alert>
      ) : null}
      {loadingParts.length > 0 ? (
        <Alert severity="info" role="status" icon={<CircularProgress size={20} />}>
          {t("tachograph.loadingParts", { parts: listParts(loadingParts) })}
        </Alert>
      ) : null}
      {companyCardsTruncated ? (
        <Alert severity="warning">
          {t("tachograph.companyCardsTruncated", { count: RESULTS_LIMIT_TACHOGRAPH_COMPANY_CARD })}
        </Alert>
      ) : null}
    </>
  );
}
